$(document).ready(function() {
  const options = {method: 'GET', headers: {accept: 'application/json'}};

  // Get merchant reviews count
  var s = new XMLHttpRequest();
  s.open("GET", "https://api.reviews.io/merchant/reviews?store=zoe-lu");
  s.send();
  s.onload = function() {
    if (s.status === 200) {
      var n = JSON.parse(s.response).stats;
      var merchantReviewCount = n.total_reviews;
      var merchantAverageRating = n.average_rating;
      $(".js-reviewCounterHeader").text(merchantReviewCount);
      $(".js-reviewStarHeader").text(Number(merchantAverageRating).toFixed(2) + "/5.0");
    } else {
      console.log("bad request");
    }
  };
  
  // Get product reviews count
  fetch('https://api.reviews.io/product/rating-batch', options)
    .then(response => response.json())
    .then(response => {
      var totalProductReviews = 0;
      response.ratings.forEach(rating => {
        totalProductReviews += rating.review_count;
      });
      $(".js-productReviewCount").text(totalProductReviews);
      
      // Calculate and display the total review count
      var totalReviews = merchantReviewCount + totalProductReviews;
      $(".js-totalReviewCount").text(totalReviews);
    })
    .catch(err => console.error(err));

  $("#speen_switch").each(function() {
    var n = $(this).val();
    $("#message2").hide();
    setInterval(function() {
      $("#message1, #message2").toggle();
    }, n);
  });
  
  $(".AnnouncementBar__Wrapper").click(function() {
    if ($(window).width() < 768) {
      setTimeout(function() {
        document
          .getElementsByClassName("FloatingPanel__header")[0]
          .getElementsByClassName("cssVar-header__subheading")[1]
          .getElementsByClassName("cssVar-subheading__number")[0]
          .getElementsByTagName("strong")[0].innerHTML = merchantReviewCount;
      }, 10);
      $(".R-LauncherButton").click();
    }
  });
  
  $(".temporary-bar_close").click(function() {
    $(".temporary-bar").hide();
  });
  
});
